import styled from "styled-components";
import DialogWindow from "../ui/DialogWindow";
import DialogInput from "../ui/DialogInput";

const StyledChat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;

  padding-bottom: 1rem;
`;

/**
 * This React Component renders a chat interface, including:
 * - A chat window to display messages
 * - An input field to type and send new messages
 *
 * Features:
 * - Displays a list of messages in the chat window
 * - Allows the user to send new messages via the input field
 * - Automatically scrolls to the bottom when new messages are added
 *
 * @returns {JSX.Element} A JSX.Element that renders the chat interface
 */
function Chat() {
  return (
    <StyledChat>
      <DialogWindow />

      <DialogInput />
    </StyledChat>
  );
}

export default Chat;
